

































import { AsyncView } from 'client-website-ts-library/plugins';
import { API } from 'client-website-ts-library/services';
import { Component, Mixins } from 'vue-property-decorator';

import Form from '@/components/Forms/Form.vue';
import { FormConstructorData, FormField, FormValue } from 'client-website-ts-library/types/Forms';
import { Listing, ListingFileType } from 'client-website-ts-library/types/Listing';
import { ContextItemType } from 'client-website-ts-library/types/Context';

@Component({
  components: {
    Form,
  },
})
export default class ListingMakeAnOffer extends Mixins(AsyncView) {
  private listing: Listing | null = null;

  private formData: FormConstructorData | null = null;

  private ready = false;

  get pdfFiles() {
    if (!this.listing) return [];
    return this.listing.Files.filter((f) => f.Type === ListingFileType.PDF);
  }

  loadListing(listingId: string): Promise<Listing> {
    return new Promise<Listing>((resolve, reject) => {
      API.Listings.Get(listingId)
        .then((listing) => {
          this.listing = listing;

          this.formData = new FormConstructorData([
            {
              Type: ContextItemType.Listing,
              Id: this.listing.Id,
            },
          ]);

          this.ready = true;

          resolve(listing);

          this.$emit('updateView');
        })
        .catch(() => {
          reject();
        });
    });
  }

  created() {
    const idParam = this.$route.params.id;

    if (!idParam) {
      this.formData = new FormConstructorData();
      this.ready = true;
      this.$emit('updateView');
      return;
    }

    const guidTest = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

    if (guidTest.test(idParam)) {
      this.loadListing(idParam.split('&')[0]);
    } else {
      API.Slugs.Resolve(idParam)
        .then((resolvedSlug) => {
          if (resolvedSlug.Type === 'Listing') {
            this.loadListing(resolvedSlug.Id).then((listing) => {
              if (idParam !== listing.Slug) {
                this.$router.replace(`/make-an-offer/${listing.Slug}`);
              }
            });
          } else {
            this.$router.push('/listing-not-found');
          }
        })
        .catch(() => {
          this.$router.push('/listing-not-found');
        });
    }
  }

  private static readonly cumulativeConditionalKeys = ['Additional_Buyers'];

  handleFieldInput({ def, value }: { def: FormField; value: FormValue }): void {
    const conditionalPrefix = `conditional--${value.Key}--`;
    const isCumulative = ListingMakeAnOffer.cumulativeConditionalKeys.includes(value.Key);
    const selectedCount = value.Value === 'None' ? 0 : parseInt(String(value.Value), 10);

    const allSections = document.querySelectorAll('[class*="conditional--"]');

    allSections.forEach((section) => {
      const classList = section.className;

      if (!classList.includes(conditionalPrefix)) return;

      if (isCumulative) {
        const match = classList.match(new RegExp(`${conditionalPrefix}(\\d+)`));
        const sectionThreshold = match ? parseInt(match[1], 10) : NaN;

        if (!Number.isNaN(sectionThreshold) && sectionThreshold <= selectedCount) {
          section.classList.remove('hidden-fields');
        } else {
          section.classList.add('hidden-fields');
        }
      } else if (classList.includes(`${conditionalPrefix}${value.Value}`)) {
        section.classList.remove('hidden-fields');
      } else {
        section.classList.add('hidden-fields');
      }
    });
  }
}
